import React, { useEffect, useState} from "react";
import {CommonResult, DdnsRequestType, SingleResult, SiteInfo} from "../../type/type";
import {createDdnsHandler, getSiteOne, removeDdnsHandler} from "../../api/api";
import Loading from "components/Loading";
import {ListContentWrap, PageArticleWrap, PageHeaderTitleButtonStyle} from "components/layout/Layout";
import {ROLE_DIRECTOR} from "../../utils/commonUtils";
import {SolidPrimaryBtn, SolidPrimarySubBtn} from "components/button/Button";
import {InputWrapC } from "components/common/CommonLayout";
import styled from "styled-components";
import {DefaultModalComponent, ModalPropsInterface, ModalTitle, ModalType} from "components/ModalComponent";
import {SwitchContainer} from "components/input/Input";
import { useRecoilValue } from "recoil";
import { userRoleState } from "styles/atoms";
import { RoundIcon } from "components/common/Icon";

const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    line-height: 1.25;
`
const InputSubRow = styled.div`
    display: flex;
    gap: 1rem;
    flex-direction: column;
`

export const DdnsInformation = () => {
    // 전역 데이터
    const user_role = useRecoilValue(userRoleState);

    const [loading, setLoading] = useState<boolean>(false);

    const [modalProps, setModalProps] = useState<ModalPropsInterface>({
        isOpen: false,
        isClose: () => {},
        title: "",
        content: null,
        button: null,
        type: ""
    });

    //ddns 변경 시 필요한 요청 정보
    const [ddnsRequestDto, setDdnsRequestDto] = useState<DdnsRequestType>({
        is_ddns:0, //ddns 등록 상태 0:미등록, 1:등록 (display 용도)
        domain:"", //도메인 서브 주소
        domain_comment:"", //도메인 설명
        update_cycle_minute:0 //업데이트 주기 (분)
    })

    //정보
    const [site, setSite] = useState<SiteInfo>({
        id: 0,
        name: "",
        phone: "",
        approval: 0,
        latitude: 0,
        longitude: 0,
        company_id: 0,
        road_address: "",
        jibun_address: "",
        detail_address: "",
        road_name: "",
        road_building_number: "",
        jibun_building_number: "",
        zip_code: "",
        temp_phone: "",
        reg_date: "",
        update_date: "",
        approval_date: "",
        image_list: [],
        type: 0,
        sido: "",
        sigungu: "",
        eupmyeondong: "",
        ri: "",
        fax: "",
        email: "",
        domain_comment:"",
        full_domain:"", //풀 도메인
        main_domain:"", //메인 도메인
        sub_domain:"", //서브 도메인
        server_port:0, //서버 포트
        is_ddns:0, //ddns 등록 상태 0:미등록, 1:등록
        update_cycle_minute:500, //업데이트 주기 (분)
        check_in_start_time: "", // 평일 등교 시작 시간 yy:mm:dd
        check_in_end_time: "", // 평일 등교 종료 시간
        check_out_start_time: "", // 평일 하교 시작 시간
        check_out_end_time: "", // 평일 하교 종료 시간
        holiday_check_in_start_time: "", // 주말 등교 시작 시간 yy:mm:dd
        holiday_check_in_end_time: "", // 주말 등교 종료 시간
        holiday_check_out_start_time: "", // 주말 하교 시작 시간
        holiday_check_out_end_time: "", // 주말 하교 종료 시간
    });

    const [isValidData, setIsValidData] = useState(false);

    //업장 정보 가져오기
    async function getSite(){
        try {
            const res:SingleResult<SiteInfo> = await getSiteOne();
            if(res.code === 200){
                const data:SiteInfo = res.data;
                setSite(data);
                setDdnsRequestDto({
                    is_ddns:data.is_ddns,
                    domain:data.sub_domain,
                    domain_comment:data.domain_comment,
                    update_cycle_minute:data.update_cycle_minute ? data.update_cycle_minute : 500 //업데이트 주기가 없을 경우 기본값 500
                })
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    }

    //정보 수정 모달 열기
    function openModal(modalType: ModalType) {
        let title: ModalTitle = "DDNS 정보 수정";
        let content: JSX.Element = <></>;
        let button: JSX.Element = <></>;

        // 모달 열 때 ddnsRequestDto 초기화
        setDdnsRequestDto({
            is_ddns: site.is_ddns,
            domain: site.sub_domain,
            domain_comment: site.domain_comment,
            update_cycle_minute: site.update_cycle_minute ? site.update_cycle_minute : 500
        });

        setModalProps({
            isOpen: true,
            isClose: () => setModalProps({...modalProps, isOpen: false}),
            title: title,
            content: content,
            button: button,
            type: modalType
        });
    }

    function ButtonContent() {

        //DDNS를 OFF 할경우 ddns 삭제 처리로, ON 할 경우 ddns 등록 처리로 요청
        const handleSave = async () => {
            const confirm = window.confirm("DDNS 정보를 저장하시겠습니까?");
            if(!confirm) return;

            try {
                let result:CommonResult;
                if(ddnsRequestDto.is_ddns === 1){
                    //ddns 등록 처리
                    result = await createDdnsHandler(ddnsRequestDto);
                }
                else{
                    //ddns 삭제 처리
                    result = await removeDdnsHandler();
                }

                if(result.code === 200){
                    alert("DDNS 정보가 저장되었습니다.");
                }
                else{
                    alert("DDNS 정보 저장에 실패하였습니다.");
                }
            }
            catch (error) {
                console.error(error);
            }
            finally {
                getSite();
                setModalProps({...modalProps, isOpen: false});
            }
        }

        return (
            <SolidPrimaryBtn className="default-bottom-btn" onClick={handleSave} disabled={!isValidData}>
                저장
            </SolidPrimaryBtn>
        )
    }


    //정보 수정 모달 content
    function ModalContent() {
        function handleSwitchChange(){
            setDdnsRequestDto({...ddnsRequestDto, is_ddns: ddnsRequestDto.is_ddns === 0 ? 1 : 0});
        }

        function handleInputChange(e:React.ChangeEvent<HTMLInputElement>){
            const {name, value} = e.target;
            setDdnsRequestDto({...ddnsRequestDto, [name]: value});
        }

        return (
            <InputWrapC>
                <div style={{paddingBottom:'1rem'}}>
                    <SwitchContainer checked={ddnsRequestDto.is_ddns === 1} onClick={handleSwitchChange}/>
                </div>
                <InputContainer>
                    <InputWrapC>
                        <InputSubRow>
                            <label>도메인 명칭 (한글 가능)</label>
                            <input type="text" name="domain_comment"
                                    onChange={handleInputChange}
                                    value={ddnsRequestDto.domain_comment}
                                    disabled={ddnsRequestDto.is_ddns === 0}
                                    placeholder="도메인 명칭 입력"
                            />
                        </InputSubRow>
                    </InputWrapC>

                    <InputWrapC>
                        <InputSubRow>
                            <label>서브 도메인 주소(소문자/숫자/하이픈(-)만 사용 가능)</label>
                            <input type="text" name="domain"
                                   onChange={handleInputChange}
                                   value={ddnsRequestDto.domain}
                                   disabled={ddnsRequestDto.is_ddns === 0}
                                   placeholder="서브 도메인 주소 입력"
                            />
                        </InputSubRow>
                    </InputWrapC>

                    <InputWrapC>
                        <InputSubRow>
                            <label>업데이트 주기 (분 단위)</label>
                            <input type="number" name="update_cycle_minute"
                                   onChange={handleInputChange}
                                   value={ddnsRequestDto.update_cycle_minute}
                                   disabled={ddnsRequestDto.is_ddns === 0}
                                   placeholder="업데이트 주기 입력(분 단위)"
                            />
                        </InputSubRow>
                    </InputWrapC>
                </InputContainer>
            </InputWrapC>
        )
    }

    // 입력 유효성 검사
    const validateDdnsInfo = () => {
        // ddns 기존 활성 -> 비활성화으로 변경하는 경우
        if (site.is_ddns && !ddnsRequestDto.is_ddns) {
            setIsValidData(true);
            return;
        }

        // 서브 도메인 주소 유효성 검사 진행(소문자/숫자/하이픈)
        const regex = /^(?!-)[a-z0-9-]+(?<!-)$/;
        
        // ddns 활성화 + 모두 입력한 경우
        if (ddnsRequestDto.domain && ddnsRequestDto.domain_comment && ddnsRequestDto.update_cycle_minute) {
            const isValid = regex.test(ddnsRequestDto.domain);
            if (!isValid) setIsValidData(false);
            else setIsValidData(true);
        }
        else {
            setIsValidData(false);
        }
    }

    useEffect(() => {
        getSite();
    }, []);

    useEffect(() => {
        validateDdnsInfo();
    }, [ddnsRequestDto]);

    return (
        loading ? (
            <Loading />
        ) : (
            <>
                <PageHeaderTitleButtonStyle>
                    <p className="header-title">DDNS 정보</p>
                </PageHeaderTitleButtonStyle>
                <PageArticleWrap>
                    <article className="list-content-container" style={{gap: '1.5rem'}}>
                        <div className="article-header height-auto">
                            <p>
                                <span className="article-header-title">DDNS 정보</span>
                            </p>
                            {user_role === ROLE_DIRECTOR &&
                                <SolidPrimarySubBtn type="button" className="default-btn" onClick={() => {openModal('updateDdns');}}>
                                    수정
                                </SolidPrimarySubBtn>
                            }
                        </div>
                        {/* <SwitchContainer checked={site.is_ddns === 1} /> */}
                        <div>
                            <RoundIcon text={site.is_ddns === 1 ? "활성화" : "비활성화" } type={site.is_ddns === 1 ? "primary" : "disabled"} />
                        </div>
                        <ListContentWrap style={{height: 'auto', width: '50%'}}>
                            <InputContainer>
                                <InputWrapC>
                                    <label>명칭</label>
                                    <input type="text" value={site.domain_comment} readOnly />
                                </InputWrapC>
                            </InputContainer>
                            <InputContainer>
                                <InputWrapC>
                                    <label>도메인 주소</label>
                                    <input type="text" value={site.full_domain} readOnly />
                                </InputWrapC>
                            </InputContainer>
                            <InputContainer>
                                <InputWrapC>
                                    <label>서브 도메인 주소</label>
                                    <input type="text" value={site.sub_domain} readOnly />
                                </InputWrapC>
                            </InputContainer>
                            <InputContainer>
                                <InputWrapC>
                                    <label>메인 도메인 주소</label>
                                    <input type="text" value={site.main_domain} readOnly />
                                </InputWrapC>
                            </InputContainer>
                            <InputContainer>
                                <InputWrapC>
                                    <label>서버 포트</label>
                                    <input type="text" value={site.server_port} readOnly />
                                </InputWrapC>
                            </InputContainer>
                        </ListContentWrap>
                    </article>
                </PageArticleWrap>
                <DefaultModalComponent isOpen={modalProps.isOpen}
                                       content={ModalContent()}
                                       button={ButtonContent()}
                                       type={modalProps.type}
                                       isClose={modalProps.isClose}
                                       title={modalProps.title} />
            </>
        )
    );
}